import { render } from "./SceneCard.vue?vue&type=template&id=21fd23a9&ts=true"
import script from "./SceneCard.vue?vue&type=script&lang=ts"
export * from "./SceneCard.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__